export const environment = {
  production: true,
  systemId: 331,
  api: {
    url: 'https://api-cidadaodigital.betha.cloud/api',
  },
  authentication: {
    scope:
      'admin.cidadao-digital,contas-usuarios.suite,glb.suite,notifications.suite,sistema_interno,user-accounts.suite,licenses.suite',
    clientId: '357d12d5-1e43-4efc-bcef-611638b325ed',
  },
  externalResources: {
    envJsUrl: 'https://variaveis.plataforma.betha.cloud/env.js',
  },
};
